import "./OrgDashboardOverview.css";
import { useAuth } from "../../hooks/useAuth";
import { useOrganizationStats } from "../../hooks/useOrganizationStats";

const formatNumber = (value: number): string => value.toLocaleString();

const OrgDashboardOverview = () => {
  const { user } = useAuth();
  const organizationId = user?.activeOrganization?.organizationId;
  const { stats, loading, error, reload } = useOrganizationStats(organizationId);

  return (
    <div className="orgdash">
      <div className="orgdash-header">
        <h2>Organization Dashboard</h2>
        <p>
          Welcome, {user?.userName ?? "there"} — an overview for{" "}
          {user?.activeOrganization?.name ?? "your organization"}
        </p>
      </div>

      {loading ? (
        <p className="orgdash-status">Loading dashboard stats...</p>
      ) : error ? (
        <div className="orgdash-status">
          <p>{error}</p>
          <button type="button" className="orgdash-retry" onClick={reload}>
            Retry
          </button>
        </div>
      ) : (
        <div className="orgdash-grid">
          <div className="orgdash-card">
            <span className="orgdash-card__label">Total Clients</span>
            <span className="orgdash-card__value">
              {formatNumber(stats.totalClients)}
            </span>
          </div>
          <div className="orgdash-card">
            <span className="orgdash-card__label">Appointments This Month</span>
            <span className="orgdash-card__value">
              {formatNumber(stats.appointmentsThisMonth)}
            </span>
          </div>
          <div className="orgdash-card">
            <span className="orgdash-card__label">Earnings This Month</span>
            <span className="orgdash-card__value">
              ৳ {formatNumber(stats.earningsThisMonth)}
            </span>
          </div>
          <div className="orgdash-card">
            <span className="orgdash-card__label">New Inquiries</span>
            <span className="orgdash-card__value">
              {formatNumber(stats.newInquiries)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgDashboardOverview;